interface SpinnerProps {
  size?: number;
  color?: string;
  className?: string;
}

export function Spinner({ size = 24, color = 'currentColor', className = '' }: SpinnerProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={`mi-anim-spin ${className}`}
      aria-label="Cargando"
    >
      <circle
        cx="12" cy="12" r="10"
        stroke={color}
        strokeWidth={2.5}
        strokeOpacity={0.2}
      />
      <path
        d="M12 2a10 10 0 0 1 10 10"
        stroke={color}
        strokeWidth={2.5}
        strokeLinecap="round"
      />
    </svg>
  );
}
